import React from 'react'

import PropTypes from 'prop-types'
import { useMediaQuery, usePopup } from '@deseretbook/react-utils'
import { Box, Button, useTheme } from '@deseretbook/react-ui'
import PlusCircle from '@deseretbook/icons/react/plus-circle'
import { SignupModal } from '../../../subscriptions'

/**
 * Lists available options for the product.
 * Everything from watch, view trailer, and purchase options
 *
 * @returns {function} React Component
 */
export const Options = ({
  user = {},
  trailer = {},
  videoUrl = '',
  activatePlayer,
  isDeseretVideoSubscriber,
}) => {
  const theme = useTheme()

  const [hasDeseretVideo, setHasDeseretVideo] = React.useState(isDeseretVideoSubscriber)

  // For when the content reaches its tablet breakpoint
  const isTabletOrSmaller = useMediaQuery({ maxWidth: 767 })
  const signupModal = usePopup()

  const hasPlusModal = !isDeseretVideoSubscriber

  return (
    <React.Fragment>
      {hasPlusModal && (
        <SignupModal
          popupProps={signupModal.popupProps}
          user={user}
          onClose={signupModal.close}
          onSuccess={() => {
            setHasDeseretVideo(true)
          }}
          documentUID="product-deseret-video"
          documentType="subscription_signup_v1"
        />
      )}

      <Box paddingRight={isTabletOrSmaller ? 0 : 1}>
        {hasDeseretVideo ? (
          <Button
            isFullwidth={isTabletOrSmaller}
            type="button"
            icon="play"
            color="video"
            onClick={() => {
              activatePlayer(videoUrl)
            }}
            style={{ backgroundColor: theme.palette.seek.primary.main }}
          >
            Start Lesson
          </Button>
        ) : (
          <Button
            isFullwidth={isTabletOrSmaller}
            type="button"
            color="primary"
            onClick={() => {
              activatePlayer(videoUrl)
            }}
            {...signupModal.triggerProps}
          >
            Get Started with Deseret Video
          </Button>
        )}
      </Box>
      {trailer && trailer.url && (
        <Box paddingRight={isTabletOrSmaller ? 0 : 1}>
          <Button
            isFullwidth={isTabletOrSmaller}
            type="button"
            icon="play"
            onClick={() => {
              activatePlayer(trailer.url)
            }}
          >
            Watch Trailer
          </Button>
        </Box>
      )}

      {!isTabletOrSmaller && (
        <Box paddingRight={1} alignItems="center">
          <PlusCircle width="2.5rem" height="2.5rem" color={theme.palette.light.dark} />
        </Box>
      )}
    </React.Fragment>
  )
}

Options.propTypes = {
  trailer: PropTypes.shape({
    url: PropTypes.string,
  }),
  activatePlayer: PropTypes.func,
  template: PropTypes.string,
  user: PropTypes.shape(PropTypes.any),
  physicalVariants: PropTypes.arrayOf(PropTypes.object),
  videoUrl: PropTypes.string,
  isDeseretVideoSubscriber: PropTypes.bool,
}
